// @flow

import updateOrderItemField from '../../../Services/updateOrderItemField';
import type { UpdateOrderItemFieldParams } from '../../../types';

export default (params: UpdateOrderItemFieldParams) => async (dispatch: Function) => dispatch(updateOrderItemField(params));